import * as PropTypes from 'prop-types';
import * as React from 'react';

class RootRoute extends React.Component {
  static get propTypes() {
    return {
      children: PropTypes.node,
      routeParams: PropTypes.object,
    };
  }

  childRoutes() {
    return React.Children.map(this.props.children, (child) =>

      // eslint-disable-next-line
      // @ts-ignore
      React.cloneElement(child, { region: this.props.routeParams.region }),
    );
  }

  render() {
    return (
      <div>
        {this.childRoutes()}
      </div>
    );
  }
}

export default RootRoute;



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/reverb-js-common/root_route.jsx